import api from "@/services/api"

type SendConfirmUserCommsRequest = {
  method: "email" | "text"
}

type SendConfirmUserCommsResponse = {
  method: "email" | "text"
  recipient: string
}

export const sendConfirmUserComms = async (
  request_body: SendConfirmUserCommsRequest
): Promise<SendConfirmUserCommsResponse> => {
  const { body: response_body } =
    await api.post<SendConfirmUserCommsResponse>(
      "/onboarding/send-confirm-user-comms",
      { body: request_body }
    )

  return response_body
}
